import api from "./api";

const regions = {
    getSearchRegions(query) {
        return api.get('/regions', { params: query});
    },
};

export default regions;
